import axios from "axios";

const ForgotPasswordFetch = async ({ email }) => {
	let { data, status } = await axios.post(
    `https://godrej.app-assertai.com:5000/Auth/forgotpassword`,
    {
      email,
    }
  );
  return { status: status, data: data.data };
};
export default ForgotPasswordFetch;
